/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'
import { UserModel } from 'app/modules/auth/models/UserModel'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from 'setup'
import UseLogin from 'app/modules/core/hooks/users/UseLogin'
import { RoleCodeEnum } from 'app/modules/core'

export function AsideMenuMain() {
  const intl = useIntl()
  const userLogin = UseLogin()
  return (
    <>
      <AsideMenuItem
        to='/leaderboard'
        icon='/media/icons/duotune/general/gen020.svg'
        title="Leader Board"
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/grade'
        icon='/media/icons/duotune/general/gen003.svg'
        title="ดูการประเมิน"
        fontIcon='bi-app-indicator'
      />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Pages</span>
        </div>
      </div>
      <AsideMenuItem
        to='/selfAssess'
        icon='/media/icons/duotune/communication/com006.svg'
        title="ประเมินตนเอง"
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/special'
        icon='/media/icons/duotune/ecommerce/ecm007.svg'
        title="คะแนนพิเศษ"
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/job'
        icon='/media/icons/duotune/electronics/elc010.svg'
        title="Job Assignment"
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/stat'
        icon='/media/icons/duotune/graphs/gra003.svg'
        title="สถิติ"
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/profile'
        icon='/media/icons/duotune/communication/com013.svg'
        title="My Profile"
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/announce'
        icon='/media/icons/duotune/communication/com003.svg'
        title="ประกาศ"
        fontIcon='bi-app-indicator'
      />


      {userLogin.roleCode === RoleCodeEnum[RoleCodeEnum.Admin] && <>

        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Setting</span>
          </div>
        </div>
        <AsideMenuItem
          to='/setting/seasons'
          icon='/media/icons/duotune/abstract/abs047.svg'
          title="Season"
          fontIcon='bi-app-indicator'
        />
        <AsideMenuItem
          to='/setting/announce'
          icon='/media/icons/duotune/communication/com003.svg'
          title="ประกาศ"
          fontIcon='bi-app-indicator'
        />
        <AsideMenuItem
          to='/setting/self'
          icon='/media/icons/duotune/communication/com006.svg'
          title="ประเมินตนเอง"
          fontIcon='bi-app-indicator'
        />

        <AsideMenuItem
          to='/setting/self-validate'
          icon='/media/icons/duotune/communication/com006.svg'
          title="ตรวจสอบประเมินตนเอง"
          fontIcon='bi-app-indicator'
        />


        <AsideMenuItem
          to='/setting/users'
          icon='/media/icons/duotune/communication/com014.svg'
          title="User Management"
          fontIcon='bi-app-indicator'
        />


        <AsideMenuItem
          to='/setting/additional'
          icon='/media/icons/duotune/files/fil005.svg'
          title="หัวหน้าประเมินเพิ่มเติม"
          fontIcon='bi-app-indicator'
        />

        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Report</span>
          </div>
        </div>
        <AsideMenuItem
          to='/report/kpi-summary'
          icon='/media/icons/duotune/graphs/gra001.svg'
          title="สรุปภาพรวมการประเมิน"
          fontIcon='bi-app-indicator'
        />



      </>}




    </>
  )
}
